import { createClient } from '@supabase/supabase-js';
import { env } from './env';
import { clockFetch } from './sync/clock';

// The single supabase-js client (WEB_PLAN.md §1, §4.6). Same GoTrue project and accounts as the iOS app.
// `global.fetch` records the server's `Date` header so edit times can be stamped in server time (sync/clock.ts).
export const supabase = createClient(env.supabaseUrl, env.supabaseAnonKey, {
  auth: {
    flowType: 'pkce',
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
  },
  global: { fetch: clockFetch },
});
